import { createContext, useState } from 'react'
import axios from 'axios'

const authContext = createContext({
    token: '',
    isLoggedIn: false,
    adminType: '',
    login: () => { },
    logout: () => { }
})

const AuthContextProvider = (props) => {
    let intialToken = JSON.parse(localStorage.getItem('token'));

    const [token, setToken] = useState('');
    const [adminType, setAdminType] = useState('');

    if (intialToken && intialToken.length !== 0) {
        const verifyToken = async (token) => {
            try {
                const res = await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_SERVER_URL}/api/auth/verify-token`,
                    data: {
                        token
                    }
                })

                if (res && res.status === 200) {
                    setToken(token)
                    setAdminType(res.data.adminType)
                } else {
                    localStorage.removeItem('token')
                    setToken("")
                }

            } catch (error) {
                localStorage.removeItem('token')
                setToken("");
            }
        }

        verifyToken(intialToken)
    }

    const isLoggedIn = !!token;

    const login = (token, adminType) => {
        setToken(token);
        setAdminType(adminType)
        localStorage.setItem('token', JSON.stringify(token));
    }

    const logout = () => {
        setToken('');
        setAdminType('');
        localStorage.removeItem('token');
    }

    return (<authContext.Provider value={{
        token,
        isLoggedIn,
        adminType,
        login,
        logout
    }} >
        {props.children}
    </authContext.Provider>)

};

export { authContext };
export default AuthContextProvider;